import React from "react"
import * as Yup from 'yup'
import { useFormik } from 'formik'
import Ajax from '../../../../../Ajax'
import { UTCDate } from '@date-fns/utc'
import { Button, CircularProgress } from "@mui/material"
import Field from "../../../../form/fields/Field"
import { store } from '../../../../../stores/Store'
import { Alert, DisplayDictionary } from '../../../../..'
import { format } from "date-fns"
import { Icons } from "../../../../../misc/Icons"


export default function CaseDetailForm ({caseNode}) {

    const [saveScheduled, setSaveScheduled] = React.useState(false)
    const autoSaveTimer = React.useRef<NodeJS.Timeout>()

    const formik = useFormik({

        initialValues: {
            name: caseNode.name,
            notes: caseNode?.notes,
            type: caseNode?.type,
            targetDate: caseNode?.targetDate ? new UTCDate(caseNode?.targetDate) : null,
            targetDateDescription: caseNode?.targetDateDescription
        },

        validationSchema: Yup.object({
            name: Yup.string().required("This field is required"),
            notes: Yup.string().nullable(),
            type: Yup.string().nullable(),
            targetDate: Yup.date().min(new UTCDate("2020-01-01"), "Too long ago").max(new UTCDate("2090-01-01"), "Too far ahead").nullable(),
            targetDateDescription: Yup.string().nullable(),
        }),

        onSubmit: async (values, actions) => {

            var updatedCase = {...caseNode, ...values}

            await Ajax.Node.Edit("case", updatedCase).then((response) => {
                if (caseNode.name !== values.name) {
                    store.NodeStore.refreshFolderNode()
                }
            }).catch((response) => {
                Alert({message: response.data?.detail ? response.data.detail : "Couldn't update case"})
            })

            formik.resetForm()
            formik.setValues(values)
            setSaveScheduled(false)
        }
    })

    const handleChange = (e) => {
        formik.setFieldValue(e.target.name, e.target.value).then((errors) => {
            if (!Object.keys(errors).length) {
                scheduleSave()
            } else {
                setSaveScheduled(false)
                clearTimeout(null)
            }
        })
    }

    const scheduleSave = () => {
        setSaveScheduled(true)

        if (autoSaveTimer.current) {
            clearTimeout(autoSaveTimer.current)
        }
        autoSaveTimer.current = setTimeout(() => {
            formik.handleSubmit()
            clearTimeout(autoSaveTimer.current)
        }, 2000)
    }

    const disableForm = store.AppStore.checkJwtRoles(["client_account", "sponsor_account"], false)

    if (!store.AppStore.sessionInfo.accountPreferences?.show_optional_case_properties) return <></>

    return (
        <div style={{display: "grid", gap: "5px", alignItems: "center", color: "#565656"}}>
            <small>Case notes</small>
            <Field.Text
                formik
                rows={5}
                name="notes"
                label=""
                value={formik.values.notes}
                warning={formik.errors.notes ? formik.errors.notes : false}
                variant="filled"
                placeholder="Write your Case notes here..."
                onChange={handleChange} />

            <div style={{height: "14px"}}>
                {saveScheduled ? (
                    <span className="help-text">Saving...</span>
                ) : null}
            </div>
        </div>
    )
}